
























































































































































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Message, MessageBox } from 'element-ui'
import { finalize } from 'rxjs/operators'
import { translate } from '@/utils/filters'
import $Api from '@api'
import { RepaymentPageRecord, PartRepaymentData, LoanRepaymentRequest, TallyBillApproveRecord } from '@/api/model/repayment'
import * as JMath from '@/utils/math'
import store from '@/store'

@Component
export default class ManualFormComponent extends Vue {
    @Prop() private msg!: string

    @Prop() visible!: boolean

    type = 1
    bizId = 0
    calcLoading = false
    calculateData: any = []
    unpaidData: PartRepaymentData[] = []

    factTime = ''
    remark = ''
    indexs = 1

    defaultCalculateData = {
        inputAmount: 0,
        calcAmount: 0,
        capitalAmount: 0,
        interestAmount: 0,
        penaltyAmount: 0,
        feesAmount: 0,
        overdueFee:0,
    }

    @Emit('close')
    handleClose(): void {
        this.remark = ''
        this.factTime = ''
    }

    @Emit('refresh')
    handleRefresh(): void {}

    fetchData({ lid, indexs, ...rest }: RepaymentPageRecord): void {
        this.calculateData = [{ lid, indexs, ...this.defaultCalculateData }]
        this.indexs = indexs
        this.type = 1
        $Api.repaymentService.partRepaymentLoadData({ lid, indexs }).subscribe(data => {
            this.unpaidData = [data]
        })
    }

    fetchDataByTallyBill({ lid, indexs, bizId, repaymentAmount, ...rest }: TallyBillApproveRecord): void {
        this.calculateData = [{ lid, indexs, ...this.defaultCalculateData }]
        this.calculateData[0].inputAmount = repaymentAmount
        this.indexs = indexs
        this.type = 2
        this.bizId = bizId
        $Api.repaymentService.partRepaymentLoadData({ lid, indexs }).subscribe(data => {
            this.unpaidData = [data]
        })
    }

    onManualSubmit(): void {
        const [calculateItem] = this.calculateData
        const { lid, paidAmount, capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee } = this.convertCalculateData(calculateItem)
        const factTime = new Date(this.factTime).getTime()
        const { remark } = this
        const indexs = this.indexs
        const type = this.type
        const bizId = this.bizId
        const userId = store && store.state.auth.authInfo.userId
        const userName = store && store.state.auth.authInfo.displayName
        const overdueFeesAmount = overdueFee
        const params: LoanRepaymentRequest = {
            factTime,
            lid,
            paidAmount,
            capitalAmount,
            interestAmount,
            penaltyAmount,
            feesAmount,
            overdueFeesAmount,
            remark,
            indexs,
            type,
            bizId,
            userId,
            userName
        }

        const valid = this.validCalculateData(paidAmount)
        if (!valid) {
            return
        }

        MessageBox.confirm(
            translate('repayment.unpaid.partialDialog.onPartailPaidSubmit.confirm', { inputAmount: paidAmount }),
            translate('common.tip'),
            {
                confirmButtonText: translate('common.btn.confirm'),
                cancelButtonText: translate('common.btn.cancel')
            }
        )
            .then(() => {
                $Api.repaymentService.loanRepaymentToPart(params).subscribe(
                    data => {
                        Message.success(translate('repayment.unpaid.manualDialog.onPartialPaidSubmit.success') as string)
                        this.handleClose()
                        this.handleRefresh()
                    },
                    error => {
                        Message.error(error.message)
                    }
                )
            })
            .catch(() => {})
    }

    calcManualRepaymentHandler(row: PartRepaymentData): void {
        const inputAmount = Number(row.inputAmount).toFixed(2)
        const valid = this.validCalculateData(+inputAmount)

        if (!valid) {
            return
        }

        this.calcLoading = true

        $Api.repaymentService
            .calcPartRepayment({
                lid: row.lid,
                indexs: row.indexs,
                paidAmount: Number(inputAmount)
            })
            .pipe(
                finalize(() => {
                    this.calcLoading = false
                })
            )
            .subscribe(
                data => {
                    const [calculateItem] = this.calculateData
                    this.calculateData = [Object.assign(calculateItem, data)]
                },
                error => {
                    Message.error(error.message)
                }
            )
    }

    onInputHandler({ target }: any, shouldCalcTotal: boolean) {
        // Keep two decimal places by RegExp
        target.value = target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null

        if (shouldCalcTotal) {
            const [calculateItem] = this.calculateData
            const { capitalAmount, interestAmount, penaltyAmount, feesAmount ,overdueFee} = this.convertCalculateData(calculateItem)
            const total = this.sum(capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee)
            calculateItem.calcAmount = this.fixedTwo(total)
        }
    }

    convertCalculateData(calculateItem: any) {
        let { lid, inputAmount, capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee } = calculateItem

        const paidAmount = this.fixedTwo(inputAmount)
        capitalAmount = this.fixedTwo(capitalAmount)
        interestAmount = this.fixedTwo(interestAmount)
        penaltyAmount = this.fixedTwo(penaltyAmount)
        feesAmount = this.fixedTwo(feesAmount)
        overdueFee = this.fixedTwo(overdueFee)
        return {
            lid,
            paidAmount,
            capitalAmount,
            interestAmount,
            penaltyAmount,
            feesAmount,
            overdueFee
        } as { [key: string]: number }
    }

    validCalculateData(inputAmount: number): boolean {
        const isNumber = isNaN(inputAmount) === true
        const isNumberErroeMessage = translate('repayment.unpaid.partialDialog.calcPartRepaymentHandler.notNumber') as string

        if (this.validator(isNumber, isNumberErroeMessage)) {
            return false
        }

        return true
    }

    // utils
    validator(bool: boolean, message?: string, type?: string): boolean {
        if (bool) {
            Message[type || 'error'](message as string)
            return true
        } else {
            return false
        }
    }

    clearEmptyProperty(source: any): any {
        const cloneSource = Object.assign({}, source)
        Object.keys(cloneSource).forEach(key => {
            if (cloneSource[key] === '' || cloneSource[key] === null) {
                delete cloneSource[key]
            }
        })
        return cloneSource
    }

    sum(...args) {
        return args.reduce((acc, cur) => {
            acc += cur
            return acc
        }, 0)
    }

    fixedTwo = (num: number): number => {
        let val = JMath.floatMul(num, 100)
        val = JMath.floatDiv(val, 100)
        return val
    }
}
